export function useMittListeners(ctx: any, handlers: Record<string, Function>) {
  onMounted(() => {
    nextTick(() => {
      Object.keys(handlers).forEach((event) => {
        ctx.$listen(event, handlers[event])
      })
    })
  })

  onBeforeUnmount(() => {
    Object.keys(handlers).forEach((event) => {
      ctx.$unlisten(event, null)
    })
  })
}
